import useDeviceType from '../../hooks/useDeviceType';

/**
 * QuickIssueSkeleton - Loading skeleton for QuickIssue dashboard
 * Matches INITIAL render state (no selections, offences section hidden)
 */
const QuickIssueSkeleton = () => {
  const deviceType = useDeviceType();

  return (
    <div className={deviceType.getContainerMaxWidth() + ' mx-auto mt-8'}>
      <div className="p-6 bg-base-100 rounded-2xl shadow-lg overflow-visible animate-pulse">
        {/* Header */}
        <div className="flex items-center gap-2 mb-4">
          <div className="skeleton h-8 bg-base-200 rounded w-48"></div>
          <div className="skeleton h-6 w-16 bg-base-200 rounded-full"></div>
        </div>

        {/* Search Section */}
        <div className={`mb-6 bg-base-200/60 rounded-2xl ${deviceType.getCardPadding()}`}>
          <div className="skeleton h-4 bg-base-200 rounded w-36 mb-2"></div>
          <div className="skeleton h-12 bg-base-100 rounded-xl"></div>
        </div>
      </div>
    </div>
  );
};

export default QuickIssueSkeleton;
